import React from 'react'
import { atom, useRecoilValue, useSetRecoilState } from 'recoil'

type AvatarState = {
  avatarId: string
  imageUrl?: string
}

const avatarState = atom<AvatarState>({
  key: 'avatarState',
  default: { avatarId: '', imageUrl: '' },
})

/**
 * avatarStateのgetter
 */
export const useAvatarState = () => {
  return useRecoilValue(avatarState)
}

/**
 * avatarStateのsetter
 */
export const useAvatarMutators = () => {
  const setState = useSetRecoilState(avatarState)

  const setAvatar = React.useCallback(
    (avatarState: AvatarState) => setState({ ...avatarState }),
    [setState]
  )

  return { setAvatar }
}
